import React from 'react';
import './typecategogy.css'


function typecategogy () {
    
        return (
            <div>
                 <div className="container-fluid categoryPageWrapper">
      <div className="row justify-content-center">
        <div className="">
          <div className="categoryPageContainer">
            {/* <!-- TITLE --> */}
            <div className="categoryPageTitleSection">
              <div className="categoryPageTitleBox">
                <div className="categoryPageMainTitle">
                  Loại danh mục
                </div>

                <div className="categoryPageBreadcrumbType">
                  <div className="categoryPageBreadcrumbTypeItem">
                    Trang chủ
                  </div>

                  <div className="categoryPageBreadcrumbTypeDivider">
                    /
                  </div>

                  <div className="categoryPageBreadcrumbTypeTypeItem">
                    Quản trị hệ thống
                  </div>

                  <div className="categoryPageBreadcrumbTypeDivider">
                    /
                  </div>

                  <div className="categoryPageBreadcrumbTypeItem">
                    Danh mục dùng chung
                  </div>

                  <div className="categoryPageBreadcrumbTypeDivider">
                    /
                  </div>

                  <div className="categoryPageBreadcrumbTypeItem">
                    Loại danh mục
                  </div>
                </div>
              </div>

              <button className="categoryPageAddButton">
                <i
                  className="fa-solid fa-plus categoryPageAddButtonIcon"
                ></i>

                Thêm loại danh mục
              </button>
            </div>

            {/* <!-- FILTER --> */}
            <div className="categoryFilterWrapper">
              <div className="row">
                <div className="col-sm-3">
                  <label className="categoryFilterLabel">
                    Tên loại danh mục
                  </label>

                  <div className="categoryFilterInputWrapper">
                    <input
                      type="text"
                      className="categoryFilterInput"
                      placeholder="Nhập tên loại danh mục..."
                    />

                    <i
                      className="fa-solid fa-magnifying-glass categoryFilterSearchIcon"
                    ></i>
                  </div>
                </div>

                <div className="col-sm-3">
                  <label className="categoryFilterLabel">
                    Mã loại danh mục
                  </label>

                  <div className="categoryFilterInputWrapper">
                    <input
                      type="text"
                      className="categoryFilterInput"
                      placeholder="Nhập mã loại danh mục..."
                    />
                  </div>
                </div>

                <div className="col-sm-3">
                  <label className="categoryFilterLabel">
                    Trạng thái
                  </label>

                  <select className="categoryFilterSelect">
                    <option>-- Tất cả --</option>
                    <option>Hoạt động</option>
                    <option>Không hoạt động</option>
                  </select>
                </div>

                <div className="col-sm-3">
                  <div className="categoryFilterActionWrapper">
                    <button className="categoryFilterResetButton">
                      <i className="fa-solid fa-rotate-right icon-solid-rotage"></i>

                      Đặt lại
                    </button>

                    <button className="category-filter-search-button">
                      <i className="fa-solid fa-magnifying-glass icon-solid-glass"></i>

                      Tìm kiếm
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- TABLE --> */}
            <div className="categoryTableCard">
              <div className="categoryTableHeader">
                <div className="categoryTableTitle">
                  Danh sách loại danh mục
                </div>

                <button className="categoryTableRefreshButton">
                  <i className="fa-solid fa-rotate-right"></i>
                </button>
              </div>

              <div className="categoryTableResponsive">
                <table className="categoryTableElement">
                  <thead>
                    <tr className="categoryTableHeadRow">
                      <th className="categoryTableHeadCell">STT</th>

                      <th className="categoryTableHeadCell">
                        Tên loại danh mục
                      </th>

                      <th className="categoryTableHeadCell">
                        Mã loại danh mục
                      </th>

                      <th className="categoryTableHeadCell">Mô tả</th>

                      <th className="categoryTableHeadCell">
                        Trạng thái
                      </th>

                      <th className="categoryTableHeadCell">
                        Số danh mục con
                      </th>

                      <th className="categoryTableHeadCell">
                        Ngày cập nhật
                      </th>

                      <th className="categoryTableHeadCell">
                        Thao tác
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr className="categoryTableBodyRow">
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableIndexText child">
                          1
                        </div>
                      </td>

                      <td className="categoryTableBodyCell">
                        <div className="categoryTableNameText">
                          Đơn vị hành chính
                        </div>
                      </td>

                      <td className="categoryTableBodyCell">
                        DONVI_HC
                      </td>

                      <td className="categoryTableBodyCell">
                        Quản lý các đơn vị hành chính
                      </td>

                      <td className="categoryTableBodyCell">
                        <span className="categoryTableStatusBadge">
                          Hoạt động
                        </span>
                      </td>

                      <td className="categoryTableBodyCell child">
                        5
                      </td>

                      <td className="categoryTableBodyCell">
                        20/05/2024 10:30
                      </td>

                      <td className="categoryTableBodyCell">
                        <div className="categoryTableActionWrapper">
                          <button
                            className="categoryTableEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="categoryTableDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr className="categoryTableBodyRow">
                      <td className="categoryTableBodyCell child">2</td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableNameText">
                          Lĩnh vực hoạt động
                        </div>
                      </td>
                      <td className="categoryTableBodyCell">
                        LINHVUC_HD
                      </td>
                      <td className="categoryTableBodyCell">
                        Quản lý lĩnh vực hoạt động của doanh nghiệp
                      </td>
                      <td className="categoryTableBodyCell">
                        <span className="categoryTableStatusBadge">
                          Hoạt động
                        </span>
                      </td>
                      <td className="categoryTableBodyCell child">
                        8
                      </td>
                      <td className="categoryTableBodyCell">
                        20/05/2024 10:30
                      </td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableActionWrapper">
                          <button
                            className="categoryTableEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="categoryTableDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr className="categoryTableBodyRow">
                      <td className="categoryTableBodyCell child">3</td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableNameText">
                          Loại hình doanh nghiệp
                        </div>
                      </td>
                      <td className="categoryTableBodyCell">
                        LOAIHINH_DN
                      </td>
                      <td className="categoryTableBodyCell">
                        Quản lý loại hình doanh nghiệp
                      </td>
                      <td className="categoryTableBodyCell">
                        <span className="categoryTableStatusBadge">
                          Hoạt động
                        </span>
                      </td>
                      <td className="categoryTableBodyCell child">
                        6
                      </td>
                      <td className="categoryTableBodyCell">
                        20/05/2024 10:30
                      </td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableActionWrapper">
                          <button
                            className="categoryTableEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="categoryTableDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr className="categoryTableBodyRow">
                      <td className="categoryTableBodyCell child">4</td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableNameText">
                          Quy mô doanh nghiệp
                        </div>
                      </td>
                      <td className="categoryTableBodyCell">
                        QUYMO_DN
                      </td>
                      <td className="categoryTableBodyCell">
                        Quản lý phân loại quy mô doanh nghiệp
                      </td>
                      <td className="categoryTableBodyCell">
                        <span className="categoryTableStatusBadge">
                          Hoạt động
                        </span>
                      </td>
                      <td className="categoryTableBodyCell child">
                        4
                      </td>
                      <td className="categoryTableBodyCell">
                        20/05/2024 10:30
                      </td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableActionWrapper">
                          <button
                            className="categoryTableEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="categoryTableDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr className="categoryTableBodyRow">
                      <td className="categoryTableBodyCell child">5</td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableNameText">
                          Ngành nghề kinh doanh
                        </div>
                      </td>
                      <td className="categoryTableBodyCell">
                        NGANHNGHE_KD
                      </td>
                      <td className="categoryTableBodyCell">
                        Quản lý ngành nghề kinh doanh
                      </td>
                      <td className="categoryTableBodyCell">
                        <span className="categoryTableStatusBadge">
                          Hoạt động
                        </span>
                      </td>
                      <td className="categoryTableBodyCell child">
                        12
                      </td>
                      <td className="categoryTableBodyCell">
                        20/05/2024 10:30
                      </td>
                      <td className="categoryTableBodyCell">
                        <div className="categoryTableActionWrapper">
                          <button
                            className="categoryTableEditButton"
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>

                          <button
                            className="categoryTableDeleteButton"
                          >
                            <i
                              className="fa-regular fa-trash-can"
                            ></i>
                          </button>
                        </div>
                      </td>

                    </tr>
                      {/* <!-- 6 --> */}
  <tr className="categoryTableBodyRow">
    <td className="categoryTableBodyCell child">6</td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableNameText">
        Trạng thái hồ sơ
      </div>
    </td>

    <td className="categoryTableBodyCell">TRANGTHAI_HS</td>

    <td className="categoryTableBodyCell">
      Quản lý trạng thái xử lý hồ sơ
    </td>

    <td className="categoryTableBodyCell">
      <span className="categoryTableStatusBadge">
        Hoạt động
      </span>
    </td>

    <td className="categoryTableBodyCell child">7</td>

    <td className="categoryTableBodyCell">
      20/05/2024 10:30
    </td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableActionWrapper">
        <button className="categoryTableEditButton">
          <i className="fa-solid fa-pen"></i>
        </button>

        <button className="categoryTableDeleteButton">
          <i className="fa-regular fa-trash-can"></i>
        </button>
      </div>
    </td>
  </tr>

  {/* <!-- 7 --> */}
  <tr className="categoryTableBodyRow">
    <td className="categoryTableBodyCell child">7</td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableNameText">
        Hình thức xử lý
      </div>
    </td>

    <td className="categoryTableBodyCell">HINHTHUC_XL</td>

    <td className="categoryTableBodyCell">
      Quản lý hình thức xử lý hồ sơ
    </td>

    <td className="categoryTableBodyCell">
      <span className="categoryTableStatusBadge">
        Hoạt động
      </span>
    </td>

    <td className="categoryTableBodyCell child">5</td>

    <td className="categoryTableBodyCell">
      20/05/2024 10:30
    </td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableActionWrapper">
        <button className="categoryTableEditButton">
          <i className="fa-solid fa-pen"></i>
        </button>

        <button className="categoryTableDeleteButton">
          <i className="fa-regular fa-trash-can"></i>
        </button>
      </div>
    </td>
  </tr>

  {/* <!-- 8 --> */}
  <tr className="categoryTableBodyRow">
    <td className="categoryTableBodyCell child">8</td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableNameText">
        Nguồn gốc xuất xứ
      </div>
    </td>

    <td className="categoryTableBodyCell">NGUONGOC_XX</td>

    <td className="categoryTableBodyCell">
      Quản lý nguồn gốc xuất xứ hàng hóa
    </td>

    <td className="categoryTableBodyCell">
      <span className="categoryTableStatusBadge">
        Hoạt động
      </span>
    </td>

    <td className="categoryTableBodyCell child">3</td>

    <td className="categoryTableBodyCell">
      20/05/2024 10:30
    </td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableActionWrapper">
        <button className="categoryTableEditButton">
          <i className="fa-solid fa-pen"></i>
        </button>

        <button className="categoryTableDeleteButton">
          <i className="fa-regular fa-trash-can"></i>
        </button>
      </div>
    </td>
  </tr>

  {/* <!-- 9 --> */}
  <tr className="categoryTableBodyRow">
    <td className="categoryTableBodyCell child">9</td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableNameText">
        Đơn vị tính
      </div>
    </td>

    <td className="categoryTableBodyCell">DONVITINH</td>

    <td className="categoryTableBodyCell">
      Quản lý các đơn vị tính
    </td>

    <td className="categoryTableBodyCell">
      <span className="categoryTableStatusBadge">
        Hoạt động
      </span>
    </td>

    <td className="categoryTableBodyCell child">10</td>

    <td className="categoryTableBodyCell">
      20/05/2024 10:30
    </td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableActionWrapper">
        <button className="categoryTableEditButton">
          <i className="fa-solid fa-pen"></i>
        </button>

        <button className="categoryTableDeleteButton">
          <i className="fa-regular fa-trash-can"></i>
        </button>
      </div>
    </td>
  </tr>
{/* 
  <!-- 10 --> */}
  <tr className="categoryTableBodyRow">
    <td className="categoryTableBodyCell child">10</td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableNameText">
        Mức độ ưu tiên
      </div>
    </td>

    <td className="categoryTableBodyCell">MUCDO_UTIEN</td>

    <td className="categoryTableBodyCell">
      Quản lý mức độ ưu tiên
    </td>

    <td className="categoryTableBodyCell">
      <span className="categoryTableStatusBadge">
        Hoạt động
      </span>
    </td>

    <td className="categoryTableBodyCell child">3</td>

    <td className="categoryTableBodyCell">
      20/05/2024 10:30
    </td>

    <td className="categoryTableBodyCell">
      <div className="categoryTableActionWrapper">
        <button className="categoryTableEditButton">
          <i className="fa-solid fa-pen"></i>
        </button>

        <button className="categoryTableDeleteButton">
          <i className="fa-regular fa-trash-can"></i>
        </button>
      </div>
    </td>
     </tr>
                  </tbody>
                </table>
              </div>

              {/* <!-- PAGINATION --> */}
              <div className="categoryPaginationWrapper">
                <div className="categoryPaginationLeft">
                  <div className="categoryPaginationText">
                    Hiển thị
                  </div>

                  <select className="categoryPaginationSelect">
                    <option>10</option>
                  </select>

                  <div className="categoryPaginationText">
                    dòng trên mỗi trang
                  </div>
                </div>

                <div className="categoryPaginationRight">
                  <div className="categoryPaginationInfo">
                    1 - 10 trong 18
                  </div>

                  <button className="categoryPaginationButton">
                    <i className="fa-solid fa-angle-left"></i>
                  </button>

                  <button
                    className="categoryPaginationButton categoryPaginationButtonActive"
                  >
                    1
                  </button>

                  <button className="categoryPaginationButton">
                    2
                  </button>

                  <button className="categoryPaginationButton">
                    <i className="fa-solid fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
            </div>
        );
    
}



export default typecategogy;